module.exports = __webpack_public_path__ + "img/left.d02055e8.webp";